import { projectInterface } from '../interface';
import { JsonCorrecter } from './jsonCorrecter';

/**
 * @ignore Property Rights
 */
export class JsonConverter extends JsonCorrecter {
    public clean(project): void {
        this.correct(project);
        this.translate(project);
    }

    private translate(project) {
        this.translatePlugins(project);
        this.translatePalettes(project);
        this.translateAllPointofviews(project);
        this.translateAllContents(project);
    }

    private translatePalettes(project) {
        // Materials
        if (project.materials !== undefined) {
            // Check after Changes inventory to arrays instead of objects
            const materials = [];
            if (typeof project.materials === 'object') {
                const keys = Object.keys(project.materials);
                keys.forEach((key) => {
                    const mat = project.materials[key];
                    materials.push(this.recursiveJsonToObject(projectInterface.material, mat));
                });
            } else {
                for (let i = 0; i < project.materials.length; i++) {
                    const mat = project.materials[i];
                    materials[i] = this.recursiveJsonToObject(projectInterface.material, mat);
                }
            }
            project.materials = materials;
        }
    }

    /**
     * @ignore Property Rights
     */
    private translatePlugins(project) {
        project.camera = this.recursiveJsonToObject(projectInterface.camera, project.camera);
        project.environment = this.recursiveJsonToObject(
            projectInterface.environment,
            project.environment
        );
        project.pipeline = this.recursiveJsonToObject(projectInterface.pipeline, project.pipeline);
    }

    /**
     * @ignore Property Rights
     */
    private translateAllPointofviews(project) {
        //! If in viewer, we do not have the point of views
        if (!projectInterface.pointofview) return;
        if (!project.pointofviews) project.pointofviews = {};
        const pointofviewsArray = [];
        const keys = Object.keys(project.pointofviews);
        keys.forEach((key) => {
            const pov = project.pointofviews[key];
            pointofviewsArray.push(this.recursiveJsonToObject(projectInterface.pointofview, pov));
        });
        project.pointofviews = pointofviewsArray;
    }

    /**
     * @ignore Property Rights
     */
    private translateAllContents(project) {
        const contentsArray = [];
        if (!project.contents) project.contents = {};
        const keys = Object.keys(project.contents);
        keys.forEach((key) => {
            const contentdata = project.contents[key];
            const contT = {};
            contT.contentdata = this.recursiveJsonToObject(projectInterface.content, contentdata);
            const { type } = contT.contentdata;
            contT.type = type;
            contT.typedata = this.recursiveJsonToObject(projectInterface[type], contentdata);
            if (contentdata.animations) {
                contT.animations = this.translateContentAnimations(contentdata.animations);
            }
            contentsArray.push(contT);
        });
        project.contents = contentsArray;
    }

    /**
     * @ignore Property Rights
     */
    private translateContentAnimations(animations) {
        const animT = {};
        const keys = Object.keys(animations);
        keys.forEach((key) => {
            const anim = animations[key];
            animT[key] = this.recursiveJsonToObject(projectInterface.animation, anim);
        });
        return animT;
    }
}

export const jsonConverter = new JsonConverter();
